import { HelpCircle } from 'react-feather'

import { Button, UncontrolledTooltip } from 'reactstrap'
import PropTypes from 'prop-types'

const Hint = ({ children, ...props }) => {
  const { id, message, size = 'md', backgroundColor, color } = props

  const sizesToNumber = {
    sm: 16,
    md: 20,
    lg: 26
  }

  const sizeToNumber = sizesToNumber[size] || sizesToNumber.md

  return (
    <span className="hint tw-group" {...props}>
      <UncontrolledTooltip placement="top" target={id}>
        {message}
      </UncontrolledTooltip>
      <Button
        id={`hint-${id}`}
        size={size}
        style={{
          backgroundColor: backgroundColor,
          color
        }}
        color="flat"
        className="p-25 rounded-circle group-hover:tw-opacity-100 tw-opacity-50"
        onClick={(e) => e.preventDefault()}
      >
        <HelpCircle size={sizeToNumber} />
      </Button>
    </span>
  )
}

Hint.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  size: PropTypes.string
}

export default Hint
